import React from "react";
import { Body, Group, GroupHead, GroupTitle, Line, Lines, Meta, Root, Tag, Text, Trailing } from "./LogLineList.styles";
import type { LogLineListProps } from "./LogLineList.types";

/** Titled groups of rows: a kind tag, the text, and a quieter second line. */
export const LogLineList: React.FC<LogLineListProps> = ({ groups, className }) => (
  <Root className={className} data-testid="log-line-list">
    {groups.map((group) => (
      <Group key={group.id} aria-label={group.title}>
        <GroupHead>
          <GroupTitle>{group.title}</GroupTitle>
          {group.trailing ? <Trailing>{group.trailing}</Trailing> : null}
        </GroupHead>
        <Lines>
          {group.lines.map((line) => (
            <Line key={line.id}>
              <Tag $tone={line.tag.tone}>{line.tag.label}</Tag>
              <Body>
                <Text>{line.text}</Text>
                {line.meta ? <Meta>{line.meta}</Meta> : null}
              </Body>
            </Line>
          ))}
        </Lines>
      </Group>
    ))}
  </Root>
);

export default LogLineList;
